import { Divider as MuiDivider, DividerProps as MuiDividerProps } from '@mui/material'
import styled from 'styled-components'

export type DividerPropsType = MuiDividerProps

const Divider = styled(MuiDivider)<DividerPropsType>``

export default Divider
